export enum DIALOG_TYPES {
  CREATE,
  EDIT,
  UPGRADE,
  DELETE
}
